module.exports = __webpack_public_path__ + "img/360.05a3ca22.svg";